import ItemContainer from "components/features/store/products/index";

const ItemsPageContainer = () => {
  return (
    <ItemContainer  as={"page"}/>
  )
}

export default ItemsPageContainer;